import { render, staticRenderFns } from "./HeroForm.vue?vue&type=template&id=46afa847&scoped=true"
import script from "./HeroForm.vue?vue&type=script&lang=js"
export * from "./HeroForm.vue?vue&type=script&lang=js"
import style0 from "./HeroForm.vue?vue&type=style&index=0&id=46afa847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46afa847",
  null
  
)

export default component.exports